import _ from "lodash";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { connect, useSelector } from "react-redux";
import { getFormValues, isPristine } from "redux-form";
import { Grid, Header } from "semantic-ui-react";
import { getNativeTemplate } from "../../firebase";
import Form from "./form";
import Info from "./info";
import Loading from "../../app/loading";
import { EditButton, CancelButton, DuplicateButton } from "../utils/buttons";
import Banner from "./banner";

const Stage = ({
  standardForm,
  location,
  id,
  template,
  retailer,
  pristine,
}) => {
  const params = useParams();

  const user = useSelector((state) => state.user);
  const banner = useSelector((state) => state.banner);

  const [bannerData, setBannerData] = useState({});
  const [templateName, setTemplateName] = useState();
  const [selectors, setSelectors] = useState();
  const [includeSizeToFit, setIncludeSizeToFit] = useState(false);
  const [inEdit, setInEdit] = useState();
  const [formOrInfo, setFormOrInfo] = useState(<Info />);
  //const [path, setPath] = useState();

  useEffect(() => {
    const data = standardForm || banner;
    setBannerData(data);
    return () => {
      setBannerData({});
    };
  }, [standardForm, banner]);

  useEffect(() => {
    if (templateName) {
      getNativeTemplate(retailer, templateName).then((data) => {
        if (data && data.selectors) {
          setSelectors(data.selectors);
          setIncludeSizeToFit(data.sizeToFit);
        }
      });
    }
  }, [templateName, retailer]);

  useEffect(() => {
    if (template) {
      setTemplateName(template);
    }
  }, [template]);

  useEffect(() => {
    if (!_.isEmpty(bannerData)) {
      setTemplateName(bannerData.bannerType);
    }
  }, [bannerData]);

  useEffect(() => {
    const loc = location.pathname.split("/");
    const status = loc[4] ? true : false;
    setInEdit(status);
  }, [location.pathname]);

  useEffect(() => {
    if ((user && params["*"] === "edit") || (user && params["template"])) {
      setFormOrInfo(<Form retailer={retailer} />);
    } else {
      setFormOrInfo(<Info />);
    }
  }, [params, user, retailer]);

  if (!bannerData || !selectors) return <Loading />;

  return (
    <>
      <Grid padded>
        <Grid.Row className="bm-title-row">
          <Grid.Column computer={10} tablet={8} mobile={16}>
            <Header as="h3" content={bannerData.bannerTitle} />
          </Grid.Column>
          {user && (
            <Grid.Column computer={6} tablet={8} mobile={16}>
              {bannerData.key && !inEdit && (
                <DuplicateButton
                  data={bannerData}
                  location={location}
                  inUse={bannerData.currentUser}
                  size="mini"
                />
              )}
              {!inEdit && (
                <EditButton
                  id={id}
                  inUse={bannerData.currentUser}
                  size="mini"
                />
              )}
              <CancelButton
                id={id}
                location={location}
                retailer={retailer}
                pristine={pristine}
                size="mini"
              />
            </Grid.Column>
          )}
        </Grid.Row>
      </Grid>
      <Banner
        banner={bannerData}
        selectors={selectors}
        retailer={retailer}
        includeSizeToFit={includeSizeToFit}
      />
      {formOrInfo}
    </>
  );
};

export default connect((state) => ({
  standardForm: getFormValues("standardForm")(state),
  pristine: isPristine("standardForm")(state),
}))(Stage);
